/* global theme */

if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.classList.add('bvt-search-page-suggestions');
      this.searchTimeoutID = -1;
      this.searchAbortController = null;
      this.oldSearchValue = '';
      this.searchInput = this.closest('form')?.querySelector('input[name="q"]');
      if (!this.searchInput) return;
      this.searchInput.addEventListener('input', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
    }

    cancelPendingRequest() {
      window.clearTimeout(this.searchTimeoutID);
      if (this.searchAbortController) {
        this.searchAbortController.abort();
        this.searchAbortController = null;
      }
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value.trim();
      if (valueToSearch === this.oldSearchValue) return;
      this.oldSearchValue = valueToSearch;
      this.cancelPendingRequest();

      if (valueToSearch.length < 2) {
        this.innerHTML = '';
        return;
      }

      this.searchTimeoutID = window.setTimeout(() => this.fetchSuggestions(valueToSearch), 320);
    }

    fetchSuggestions(terms) {
      this.searchAbortController = new AbortController();
      const url = new URL(theme.routes.predictiveSearch, window.location.origin);
      url.searchParams.set('q', terms);
      url.searchParams.set('section_id', 'search-suggestions');
      url.searchParams.set('resources[type]', 'query,collection');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('resources[limit_scope]', 'each');

      fetch(url, { signal: this.searchAbortController.signal })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then((text) => {
          if (this.searchInput.value.trim() !== terms) return;
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');
          this.searchAbortController = null;
          this.innerHTML = results?.dataset.suggestionCount !== '0' ? results?.innerHTML || '' : '';
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          console.warn(error); // eslint-disable-line no-console
          this.innerHTML = '';
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}
